import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "../../common/network-call";
import { INSTANCE_URL, itemCount } from "../../common/constant";
import { updateSession } from "../../../actions";

export const MY_PROFILE = "MY_PROFILE";
export const PASSWORD_MODAL = "PASSWORD_MODAL";

export function fetchMyProfile(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/tikwash/_table/appuser?related=appuser_additional_info_by_useridfk&filter=(userid=${session.userid})&order=userid%20DESC`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        dispatch({
          type: MY_PROFILE,
          payload: { data: response.resource[0] },
        });
        callback({ success: 1, data: response.resource[0] });
      },
      (error) => {}
    );
  };
}

export function updateUser(session, values, callback) {
  var url = `${INSTANCE_URL}api/v2/tikwash/_table/appuser/${session.userid}`;

  return (dispatch) => {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updatePersonalInfo(
  session,
  values,
  additionalinfoid,
  callback
) {
  var url = `${INSTANCE_URL}api/v2/tikwash/_table/appuser/${session.userid}`;
  var urladditional = `${INSTANCE_URL}/api/v2/tikwash/_table/appuser_additional_info/${additionalinfoid}`;

  return (dispatch) => {
    patchRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        let data = {};
        data.location = values.location;
        data.city = values.city;
        data.state = values.state;
        data.zipcode = values.zipcode;
        data.country = values.country;
        data.placeid = values.placeid;
        data.latitude = values.latitude;
        data.longitude = values.longitude;
        data.jsondata = values.jsondata;
        data.notifylowcredit = values.notifylowcredit;
        data.lowcreditthreshold = values.lowcreditthreshold;
        patchRequest(
          urladditional,
          data,
          session,
          dispatch,
          (response) => {
            callback({ success: 1 });
          },
          (error) => {
            callback({ success: 0, message: error });
          }
        );
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function updateCompanyinfo(session, values, additionalinfoid, callback) {
  var urladditional = `${INSTANCE_URL}/api/v2/tikwash/_table/appuser_additional_info/${additionalinfoid}`;

  return (dispatch) => {
    patchRequest(
      urladditional,
      values,
      session,
      dispatch,
      (response) => {
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function openPasswordModal(showModal) {
  return { type: PASSWORD_MODAL, payload: showModal };
}

export function changePasswordAction(session, values, callback) {
  var url = `${INSTANCE_URL}api/v2/user/password?reset=true&login=true`;

  return (dispatch) => {
    postRequest(
      url,
      values,
      session,
      dispatch,
      (response) => {
        // console.log("response :- ", response);

        // Updating session
        session = {
          ...session,
          session_token: response?.session_token,
        };
        dispatch(updateSession(session));

        setTimeout(() => {
          var returnData = { success: 1 };
          callback(returnData);
        }, 1500);
      },
      (error) => {
        var returnData = { success: 0, data: error.message };
        callback(returnData);
      }
    );
  };
}

export function fetchLocationSuggestion(session, value, callback) {
  var url = `${INSTANCE_URL}/api/v2/tikwash_script/`;

  var body = {
    session: session,
    value: value,
    type: "search_location",
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log('location response: -', response)
        callback({ success: 1, result: response.result[0].predictions });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}

export function locationDetails(session, params, callback) {
  var url = `${INSTANCE_URL}/api/v2/tikwash_script/`;

  var body = {
    session: session,
    params,
    type: "location_details",
  };
  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (response) => {
        // console.log('location response: -', response)
        callback({ success: 1, result: response.result[0].result });
      },
      (error) => {
        callback({ success: 0, message: error });
      }
    );
  };
}
